import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AboutComponent } from '../about/about.component';
import { HomeComponent } from '../home/home.component';
import { ProfileComponent } from '../profile/profile.component';
import { ModelBikeComponent } from '../model-bike/model-bike.component';
import { DeliveryTypeComponent } from '../delivery-type/delivery-type.component';
import { LoginComponent } from '../login/login.component';
import { SignupComponent } from '../signup/signup.component';
import { SampleComponent } from '../sample/sample.component';
import { ModelComponent } from '../model/model.component';
import { AuthGuard }  from '../auth.guard';
import { ReferralComponent } from '../referral/referral.component';
import { BikeSelectionComponent } from '../bike-selection/bike-selection.component';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';
import { PaymentSuccessComponent } from '../payment-success/payment-success.component';
import { UserprofileComponent } from '../userprofile/userprofile.component';
import { UserdocumentsComponent } from '../userdocuments/userdocuments.component';
import { CompletedBookingComponent } from '../completed-booking/completed-booking.component';
import { OngoingBookingComponent } from '../ongoing-booking/ongoing-booking.component';
import { VehicleDocumentsComponent } from '../vehicle-documents/vehicle-documents.component';
import { UserdetailsComponent } from '../userdetails/userdetails.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { ExtendBookingPaymentSuccessComponent } from '../extend-booking-payment-success/extend-booking-payment-success.component';
import { MyProfileComponent } from '../my-profile/my-profile.component';
import { AppRatingComponent } from '../app-rating/app-rating.component';
import { PenaltyPaymentComponent } from '../penalty-payment/penalty-payment.component';
import { TestComponent } from '../test/test.component';
// import {UrlSerializer, UrlTree, DefaultUrlSerializer} from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: ModelComponent,
    data:{title:"Ontrack: Monthly bike rental in Bangalore | Bike rentals in Bangalore"}
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'delivery',
    component: DeliveryTypeComponent
  },
  {
    path: 'login-signup',
    component: LoginComponent
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'sample',
    component: SampleComponent
  },
  {
    path: 'model',
    component: ModelComponent,
    data: {title: "Models"}
    
  },
  {
    path: 'model/:name/:id/:months',
    component: ModelBikeComponent,
    data: {title: "Model Description"}
  },
  {
    path: 'referral',
    component: ReferralComponent,
    data: {title: "Referral"}
  },
  { 
    path:'bike-model/:id/:months',
    component:BikeSelectionComponent,
    data: {title: "Ontrack: Monthly bike rental in Bangalore | Two wheelers for rent"}
  },
  {
    // path: 'success/:id',
    path: 'payment/:id', 
    component: PaymentSuccessComponent,
    data: {title: "Ontrack: Monthly bike rental in Bangalore | Two wheelers for rent"}
  },
  {
    path: 'extendpayment/:id',
    component: ExtendBookingPaymentSuccessComponent,
    data: {title: "Ontrack: Monthly bike rental in Bangalore | Two wheelers for rent"}
  },
  {
    path: 'payment/:id/:status', 
    component: PenaltyPaymentComponent,
    data: {title: "Ontrack: Monthly bike rental in Bangalore | Two wheelers for rent"}
  },
   {
    path: 'userAccount',
    component: UserprofileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'documents',
    component: UserdocumentsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'completed',
    component: CompletedBookingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'ongoing',
    component:OngoingBookingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'vehicleDocuments',
    component: VehicleDocumentsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'details',
    component: UserdetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reset/:token',
    component: ResetPasswordComponent,
    data: {title: "Ontrack: Monthly bike rental in Bangalore | Two wheelers for rent"}
  },
  {
    path: 'MyProfile',
    component: MyProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'custom/AppRating/:bookId',
    component: AppRatingComponent
  },
  {
    path: '404', 
    component: PageNotFoundComponent,
    data: {title: "Page Not Found"}
  },
  {
    path: 'test', 
    component: TestComponent,
    data: {title: "Test"}
  },

  {path: '**', redirectTo: '/404'},
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule {
  
//   parse(url: any): UrlTree {
//     let dus = new DefaultUrlSerializer();
//     return dus.parse(url);
// }

// serialize(tree: UrlTree): any {
//     let dus = new DefaultUrlSerializer(),
//         path = dus.serialize(tree);
//     // use your regex to replace as per your requirement.
//     return path.replace(/%20/g,'_').replace(/%2F/g,'_');
    
// }
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/app-routing/app-routing.module.ts